/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable prettier/prettier */
/* eslint-disable no-confusing-arrow */
/* eslint-disable react/jsx-no-bind */
import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import ReactPlayer from 'react-player';
import { BoxInput, UploadVideo } from './styles';

export function ModalVirtualDispatcherConfirmation({
  setIsModalVirtualDispatcherConfirmationOpen,
  isModalVirtualDispatcherConfirmationOpen,
  virtualDispatcherConfirmationObservation,
  setVirtualDispatcherConfirmationObservation,
  virtualDispatcherConfirmationVideo,
  setVirtualDispatcherConfirmationVideo,
}) {
  const [buttonLoading] = useState(false);

  return (
    <Modal
      title="Confirmação de envio do despachante"
      open={isModalVirtualDispatcherConfirmationOpen}
      footer={null}
      onCancel={() => setIsModalVirtualDispatcherConfirmationOpen(false)}
      width={900}
    >

      <UploadVideo>
        <h3>
          Vídeo
        </h3>

        <div className="video">
          {
            virtualDispatcherConfirmationVideo && (
              <ReactPlayer controls url={URL.createObjectURL(virtualDispatcherConfirmationVideo)} />
            )
          }

          <label htmlFor="avatar" className="">
            <div className="button">
              <UploadOutlined />
              Fazer upload
            </div>

            <input
              id="avatar"
              type="file"
              onChange={(event) => setVirtualDispatcherConfirmationVideo(event.target.files[0])}
            />
          </label>
        </div>
      </UploadVideo>

      <BoxInput>
        <label htmlFor="description">
          Observação
        </label>
        <textarea
          value={virtualDispatcherConfirmationObservation}
          onChange={(event) => setVirtualDispatcherConfirmationObservation(event.target.value)}
        />

      </BoxInput>

      <div>
        <Button loading={buttonLoading} type="primary">Enviar</Button>
      </div>
    </Modal>
  );
}
